<template>
  <div class="mobile-home container">
    <img alt="logo" src="@/assets/logo.png" />
    <p>
      The S&P Global Market Intelligence API Solutions, using Restful APIs,
      provides on-demand enterprise data access more securely and with fewer
      resources than traditional data feeds.
    </p>
    <p>
      Access a comprehensive list of financial and non-financial data sets
      allowing you to pick and choose the data you need without hosting a
      database.
    </p>
    <p>
      Developers can leverage secure web services to dynamically access S&P
      Global datasets, and curated third-party datasets, or can interact
      directly with the web services via REST/JSON.
    </p>
    <p>
      This website is for demonstration with the S&P Global API dataset written
      in Vue 3.
    </p>

    <nav class="actions">
      <router-link v-if="isLoggedIn" class="btn" to="/mobile/dashboard1">Dashboard1</router-link>
      <router-link v-if="isLoggedIn" class="btn" to="/mobile/dashboard2">Dashboard2</router-link>
      <router-link v-if="isLoggedIn" class="btn" to="/mobile/dashboard3">Dashboard3</router-link>
      <router-link v-if="isLoggedIn" class="btn" to="/mobile/dashboard4">Dashboard4</router-link>
      <router-link v-if="isLoggedIn" class="btn" to="/mobile/dashboard5">Dashboard5</router-link>
      <router-link v-if="isLoggedIn" class="btn" to="/mobile/dashboard6">Dashboard6</router-link>
      <router-link v-if="isLoggedIn" class="btn" to="/mobile/dashboard7">Dashboard7</router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'MobileHome',
  computed: {
    isLoggedIn(){ return this.$store.state.auth.status.loggedIn }
  }
};
</script>

<style scoped>
.mobile-home { padding: 12px; font-family: Arial, Helvetica, sans-serif; text-align:left }
.mobile-home img { max-width:160px; display:block; margin:8px 0 }
.actions { display:flex; gap:8px; margin-top:14px; flex-wrap:wrap }
.btn { display:inline-block; padding:10px 12px; background:#007a3f; color:#fff; text-decoration:none; border-radius:6px; font-size:14px }
.mobile-home p { font-size:14px; color:#222; margin:8px 0 }
</style>